// App.js
import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from './layout/Layout';
import DashboardLayout from './dashboard/DashboardLayout';
import Home from './pages/Home';
import NoPage from './pages/NoPage';
import Login from './auth/forms/Login';
import Register from './auth/forms/Register';
import ForgotPassword from './auth/forms/ForgotPassword';
import OTPVerification from './auth/forms/OTPVerification';
import ChangePassword from './auth/forms/ChangePassword';
import PasswordReset from './auth/forms/PasswordReset';
import AuthProvider from './auth/AuthContext';
import ReportProvider from './reports/ReportContext';
import ReportIssue from './reports/forms/ReportIssue';
import Dashboard from './dashboard/Dashboard';
import Reports from './reports/Reports';
import Issues from './reports/issues/Issues';
import SingleReportView from './reports/SingleReportView';
import SingleIssueView from './reports/issues/SingleIssueView';
import IssuesAssigned from './reports/issues/IssuesAssigned';
import MyIssues from './reports/issues/MyIssues';
import ProposedSolutions from './reports/solutions/ProposedSolutions';
import ReviewProvider from './reviews/ReviewContext';
import Reviews from './reviews/Reviews';
import MyReviews from './reviews/MyReviews';
import AddReview from './reviews/forms/AddReview';
import Profile from './profile/Profile';
import AllAdmins from './profile/AllAdmins';
import AdminRegistration from './profile/forms/AdminRegistration';
import { PrivacyPolicy } from './documents/PrivacyPolicy';
import { TermsAndConditions } from './documents/TermsAndConditions';
import ContactUsSection from './contact/ContactUsSection';
import ContactProvider from './contact/ContactContext';
import Contacts from './contact/Contacts';
import UserManagement from './auth/UserManagement';
import { StatsProvider } from './stats/StatsContext';
import UserPoints from './points/UserPoints';
import ManagePoints from './points/ManagePoints';
import PointsProvider from './points/PointsContext';

export default function App() {
  return (
    <BrowserRouter>
      <StatsProvider>
        <AuthProvider>
          <ReportProvider>
            <ReviewProvider>
              <ContactProvider>
                <PointsProvider>
                  <Routes>
                    {/* Main Layout Routes */}
                    <Route path="/" element={<Layout />}>
                      <Route index element={<Home />} />
                      <Route path="*" element={<NoPage />} />

                      {/* Auth Routes */}
                      <Route path="login" element={<Login />} />
                      <Route path="register" element={<Register />} />
                      <Route path="forgot-password" element={<ForgotPassword />} />
                      <Route path="/:userId/verification" element={<OTPVerification />} />
                      <Route path="password/change" element={<ChangePassword />} />
                      <Route path="password/reset/:userId" element={<PasswordReset />} />
                      <Route path="register-specialist" element={<AdminRegistration />} />

                      {/* Reports Routes */}
                      <Route path="report" element={<ReportIssue />} />
                      <Route path="reports/:type" element={<Reports />} />
                      <Route path="reports/:reportId/details" element={<SingleReportView />} />

                      {/* Issues Routes */}
                      <Route path="issues" element={<Issues />} />
                      <Route path="issues/:issueId" element={<SingleIssueView />} />

                      {/* Reviews Routes */}
                      <Route path="reviews/add/:issueId" element={<AddReview />} />
                      <Route path="reviews" element={<Reviews />} />
                      <Route path="my-reviews" element={<MyReviews />} />

                      {/* Other Routes */}
                      <Route path="privacy" element={<PrivacyPolicy />} />
                      <Route path="terms" element={<TermsAndConditions />} />
                      <Route path="contact/form" element={<ContactUsSection />} />
                      <Route path="contact" element={<Contacts />} />
                    </Route>

                    {/* Dashboard Layout Routes - All dashboard routes go here */}
                    <Route path="/dashboard" element={<DashboardLayout />}>
                      <Route index element={<Dashboard />} />
                      
                      {/* Reports */}
                      <Route  path="reports/:type" element={<Reports />} />
                      <Route path="reports/:reportId/details" element={<SingleReportView />} />
                      
                      {/* Issues */}
                      <Route path="issues" element={<Issues />} />
                      <Route path="issues/:issueId" element={<SingleIssueView />} />
                      <Route path="issues/assigned" element={<IssuesAssigned />} />
                      <Route path="issues/solutions" element={<ProposedSolutions />} />
                      
                      {/* My Issues */}
                      <Route path="my-issues" element={<MyIssues />} />

                      {/* Points */}
                      <Route path="points" element={<UserPoints />} />
                      <Route path="manage-points" element={<ManagePoints />} /> 
                      
                      {/* Reviews */}
                      <Route path="reviews" element={<Reviews />} />
                      <Route path="my-reviews" element={<MyReviews />} />
                      <Route path="reviews/add/:issueId" element={<AddReview />} />
                      
                      {/* Profile */}
                      <Route path="profile" element={<Profile />} />
                      <Route path="password/change" element={<ChangePassword />} />
                      <Route path="admin-users" element={<AllAdmins />} />
                      
                      {/* Admin */}
                      <Route path="users/management" element={<UserManagement />} />
                      
                      {/* Contact */}
                      <Route path="contact" element={<Contacts />} />
                      <Route path="contact/form" element={<ContactUsSection />} />
                      
                      {/* Report Issue */}
                      <Route path="report" element={<ReportIssue />} />
                    </Route>
                  </Routes>
                </PointsProvider>
              </ContactProvider>
            </ReviewProvider>
          </ReportProvider>
        </AuthProvider>
      </StatsProvider>
    </BrowserRouter>
  );
}